import { createApp } from 'vue'
import pinia from "@/stores";
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import App from './App.vue'

//  defineGlobal window 注册全局
import defineGlobal from "@/globalVars";
import handleStorage from "@/utils/localstorage";
import to from "await-to-ts";

defineGlobal('$handleStorage', handleStorage);
defineGlobal('awaitTo', to);

const app = createApp(App)
app.use(pinia)
app.use(ElementPlus,{
  locale: zhCn,
})

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.mount('#app')
